import shortid from 'shortid';
import { REPLACE_SECTIONS, addSection } from 'redux/modules/sections';
import { addField, REPLACE_FIELDS } from 'redux/modules/fields';
import { REPLACE_OPTIONS } from 'redux/modules/options';
import { MERGE_IN_SETTINGS, addSectionSetting } from 'redux/modules/settings';
import { selectPage, unselectSection } from 'redux/modules/flag';
import { setChangedIDs } from 'redux/modules/changedFields';
import { isTempId } from 'api/common';
import splitPages from 'editor/utils/splitPages';

export const REPLACE_PAGES = 'REPLACE_PAGES';
const UPDATE_TEMPID_PAGE = 'UPDATE_TEMPID_PAGE';

export default function pages(state = [], action) {
    switch (action.type) {
        case REPLACE_PAGES:
            return action.payload;
        case UPDATE_TEMPID_PAGE: {
            const { mapPages = {} } = action.payload;
            const sectionsReplaceTemp = state.map(page => {
                let newSection = page;
                if (mapPages[page.id]) {
                    newSection = { ...newSection, id: mapPages[page.id] };
                }
                return newSection;
            });
            return sectionsReplaceTemp;
        }
        default:
            return state;
    }
}

export function updateTempIdPage(pages) {
    return {
        type: UPDATE_TEMPID_PAGE,
        payload: {
            mapPages: pages
        }
    };
}

export function movePagesSeq(id, targetIndex, type = 1) {
    return (dispatch, getState) => {
        const { pages } = getState();
        let { formPages, deletedFormPages, resultPages, deletedResultPages } = splitPages(pages);
        let moveSource;
        let choosePages = [];
        let restPages;
        if (type === 1) {
            choosePages = formPages;
            restPages = [...deletedFormPages, ...resultPages, ...deletedResultPages];
        } else if (type === 2) {
            choosePages = resultPages;
            restPages = [...deletedFormPages, ...formPages, ...deletedResultPages];
        }
        choosePages = choosePages.map(formPage => {
            if (formPage.id === id) {
                moveSource = formPage;
                return false;
            }
            return formPage;
        });
        choosePages.splice(targetIndex, 0, moveSource);
        choosePages = choosePages.filter(f => f).map((f, index) => ({ ...f, seq: index + 1 }));
        dispatch({
            type: REPLACE_PAGES,
            payload: [...choosePages, ...restPages]
        });
        dispatch(setChangedIDs({ pages: true }));
    };
}

export function addPage(index) {
    return (dispatch, getState) => {
        let {
            form: { id: formId },
            pages
        } = getState();
        let { formPages, deletedFormPages, resultPages, deletedResultPages } = splitPages(pages);
        const newPage = {
            id: `temp_${shortid.generate()}`,
            formId,
            type: 1
        };
        formPages.splice(index, 0, newPage);
        formPages = formPages.map((page, index) => ({ ...page, seq: index + 1 }));
        pages = [...formPages, ...resultPages, ...deletedFormPages, ...deletedResultPages];
        dispatch({ type: REPLACE_PAGES, payload: pages });
        dispatch(selectPage(newPage.id));
        dispatch(setChangedIDs({ pages: true }));
        dispatch(selectPage(newPage.id));
    };
}

export function deletePage(deletedPageId, type = 1) {
    return (dispatch, getState) => {
        let {
            pages,
            sections,
            fields,
            options,
            settings: { sections: sectionSettings, fields: fieldSettings, options: optionSettings },
            flag: { selectPageId, selectSectionId }
        } = getState();
        const changedFlag = {};
        const deletedSectionIds = [];
        const deletedFieldIds = [];
        const deletedOptionIds = [];
        let { formPages, deletedFormPages, resultPages, deletedResultPages } = splitPages(pages);
        let choosePages;
        let chooseDeletedPages;
        let restPages;
        if (type === 2) {
            choosePages = resultPages;
            chooseDeletedPages = deletedResultPages;
            restPages = [...formPages, ...deletedFormPages];
        } else {
            choosePages = formPages;
            chooseDeletedPages = deletedFormPages;
            restPages = [...resultPages, ...deletedResultPages];
        }
        const deletedPageIndex = choosePages.findIndex(page => page.id === deletedPageId);
        if (deletedPageId === selectPageId) {
            const nextPage = choosePages[deletedPageIndex + 1];
            const prevPage = choosePages[deletedPageIndex - 1];
            selectPageId = (nextPage || prevPage).id;
            dispatch(selectPage(selectPageId));
        }
        const [deletedPage] = choosePages.splice(deletedPageIndex, 1);
        if (!isTempId(deletedPageId)) {
            changedFlag.pages = true;
            chooseDeletedPages.push({ ...deletedPage, deleted: 1 });
        }
        sections = sections.filter(section => {
            const isDeletedSection =
                section.pageId === deletedPageId && (isTempId(section.id) || !section.pageIdOrigin);
            if (isDeletedSection) {
                deletedSectionIds.push(section.id);
            }
            return !isDeletedSection;
        });
        if (deletedSectionIds.includes(selectSectionId)) {
            dispatch(unselectSection(''));
        }
        sections = sections.map(section => {
            if (section.pageId === deletedPageId && section.pageIdOrigin) {
                const { pageIdOrigin, ...rest } = section;
                return { ...rest, pageId: pageIdOrigin, deleted: 1 };
            } else if (section.pageIdOrigin === deletedPageId) {
                if (isTempId(deletedPageId)) {
                    const { pageIdOrigin, ...rest } = section;
                    return rest;
                } else {
                    return { ...section, deleted: 0 };
                }
            }
            return section;
        });
        sectionSettings = sectionSettings.filter(s => !deletedSectionIds.includes(s.id));

        if (deletedSectionIds.length > 0) {
            fields = fields.filter(field => {
                const isDeleted = deletedSectionIds.includes(field.sectionId);
                if (isDeleted) {
                    deletedFieldIds.push(field.id);
                }
                return !isDeleted;
            });
            if (deletedFieldIds.length > 0) {
                fieldSettings = fieldSettings.filter(f => !deletedFieldIds.includes(f.id));
            }
        }

        if (deletedFieldIds.length > 0) {
            options = options.filter(option => {
                const isDeleted = deletedFieldIds.includes(option.fieldId);
                if (isDeleted) {
                    deletedOptionIds.push(option.id);
                }
                return !isDeleted;
            });
            if (deletedOptionIds.length > 0) {
                optionSettings = optionSettings.filter(o => !deletedOptionIds.includes(o.id));
            }
        }
        dispatch({
            type: REPLACE_PAGES,
            payload: [...choosePages, ...chooseDeletedPages, ...restPages]
        });
        dispatch({ type: REPLACE_SECTIONS, payload: sections });
        dispatch({ type: REPLACE_FIELDS, payload: fields });
        dispatch({ type: REPLACE_OPTIONS, payload: options });
        dispatch({
            type: MERGE_IN_SETTINGS,
            payload: { sections: sectionSettings, fields: fieldSettings, options: optionSettings }
        });
        dispatch(setChangedIDs(changedFlag));
    };
}

export function addPageSectionFields(index, selectField, type) {
    return (dispatch, getState) => {
        let {
            form: { id: formId },
            pages
        } = getState();
        let { formPages, deletedFormPages, resultPages, deletedResultPages } = splitPages(pages);
        const newPage = {
            id: `temp_${shortid.generate()}`,
            formId,
            type
        };
        let choosePages = [];
        let restPages;
        if (type === 1) {
            choosePages = formPages;
            restPages = [...deletedFormPages, ...resultPages, ...deletedResultPages];
        } else if (type === 2) {
            choosePages = resultPages;
            restPages = [...deletedFormPages, ...formPages, ...deletedResultPages];
        }
        choosePages.splice(index, 0, newPage);
        choosePages = choosePages.map((page, index) => ({ ...page, seq: index + 1 }));
        pages = [...choosePages, ...restPages];
        dispatch({ type: REPLACE_PAGES, payload: pages });
        dispatch(selectPage(newPage.id));

        const tempSectionId = `temp_${shortid.generate()}`;
        let fieldId;
        let fieldStatus = {};
        if (selectField.initSettings.fields) {
            fieldId = `temp_${shortid.generate()}`;
            dispatch(
                addField(
                    fieldId,
                    tempSectionId,
                    selectField.initSettings.sections.displayName,
                    null
                )
            );
            fieldStatus = { fields: true, fieldsIds: [fieldId] };
        }

        const initSectionData = {
            settings: selectField.initSettings,
            sectionId: tempSectionId,
            fieldId
        };

        dispatch(addSection({ ...selectField, id: tempSectionId }, newPage.id, tempSectionId));
        dispatch(addSectionSetting(initSectionData));
        dispatch(
            setChangedIDs({
                pages: true,
                sections: true,
                sectionsIds: [tempSectionId],
                ...fieldStatus
            })
        );
    };
}
